import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d497ff0&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./styles.scss?vue&type=style&index=0&id=0d497ff0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d497ff0",
  null
  
)

export default component.exports